import React, { useEffect, useMemo, useState } from "react";
import TableContainer from "../../../components/Common/TableContainer";
import Breadcrumb from "../../../components/Common/Breadcrumb";
import { Card, CardBody, Button, Container } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { getRecords } from "../../../services/api.service";

const breadcrumbItems = [];

const SubcontractorAndCustomerList = () => {
  const navigate = useNavigate();
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchKeyword, setSearchKeyword] = useState("");
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(10);
  const [totalCount, setTotalCount] = useState(0);
  const [dataForExport, setDataForExport] = useState([]);
  const exportFileName = "subcontractorAndCustomer.xlsx";
  useEffect(() => {
    getData();
  }, [searchKeyword, page, pageSize]);

  const getData = async () => {
    try {
      const payload = {
        modelName: "company_masters",
        search: {
          searchKeyword: searchKeyword,
          field_name: [
            "company_name",
            "contact_person_name",
            "contact_person_email",
            "address",
          ],
        },
        // relations: [
        //   {
        //     module: "company_documents",
        //     moduleAs: "documents",
        //   },
        // ],
        pagination: {
          page: page + 1,
          pageSize: pageSize,
        },
      };

      const responseData = await getRecords(payload, "/getRecords");

      responseData.data = responseData.data.filter((data) => data.id != 1);
      responseData.data.forEach((element, index) => {
        element.index = index + 1;
      });
      setTotalCount(responseData.count);

      const sortedData = responseData.data.sort((a, b) => b.index - a.index);
      setData(sortedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setIsLoading(false);
    }
  };

  const exportPageData = {
    modelName: "company_masters",
    // relations: [
    //   {
    //     module: "company_documents",
    //     moduleAs: "documents",
    //   },
    // ],
  };

  useEffect(() => {
    const handleExportData = async () => {
      try {
        const responseData = await getRecords(exportPageData, "/getRecords");
        responseData.data = responseData.data.filter((data) => data.id != 1);
        setDataForExport(responseData.data);
      } catch (error) {
        console.error("Error fetching records:", error);
      }
    };

    handleExportData();
  }, []);

  const handleClickAdd = () => {
    navigate("/subcontractor-customer-create");
  };

  const handleEditClick = (id) => {
    navigate(`/subcontractor-customer-create/${id}`);
  };
  const handleViewClick = (id) => {
    navigate(`/subcontractor-customer-view/${id}`);
  };

  const getSearchInputData = (inputValue) => {
    setSearchKeyword(inputValue);
  };

  const nextToPages = () => {
    setPage(page + 1);
  };

  const previousToPages = () => {
    setPage(page - 1);
  };

  const handlePageSizeChange = (data) => {
    setPageSize(data);
    const newTotalPages = Math.ceil(totalCount / data);
    if (page >= newTotalPages) {
      setPage(0);
    }
  };

  const lastToPages = () => {
    setPage(Math.ceil(totalCount / pageSize) - 1);
  };

  const previousFirstToPages = () => {
    setPage(0);
  };

  const columns = useMemo(
    () => [
      {
        Header: "SR.NO",
        accessor: "index",
        accessor: (row) => page * pageSize + row.index,
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "50px" }}>{value}</div>,
      },

      {
        Header: "TYPE",
        accessor: (row) =>
          row.type && row.type == 1
            ? "Subcontractor"
            : row.type == 2
            ? "Customer"
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },
      {
        Header: "COMPANY NAME",
        accessor: (row) =>
          row.company_name && row.company_name ? row.company_name : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "CONTACT PERSON",
        accessor: (row) =>
          row.contact_person_name && row.contact_person_name
            ? row.contact_person_name
            : "-",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => <div style={{ width: "150px" }}>{value}</div>,
      },

      {
        Header: "STATUS",
        accessor: "is_active",
        disableFilters: true,
        filterable: false,
        Cell: ({ value }) => (
          <div style={{ width: "100px" }}>
            {value === "Active" || value === false || value === 0 ? (
              <span className="badge bg-danger-subtle text-danger text-uppercase">
                In-active
              </span>
            ) : (
              <span className="badge bg-success-subtle text-success text-uppercase">
                Active
              </span>
            )}
          </div>
        ),
      },
      {
        Header: "ACTION",
        accessor: "actions",
        disableFilters: true,
        filterable: false,
        Cell: ({ row }) => (
          <div style={{ width: "150px", display: "flex" }}>
            <div
              onClick={() => {
                handleEditClick(row.original.id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-pencil font-size-18"></i>
              </Link>
            </div>
            <div
              onClick={() => {
                handleViewClick(row.original.id);
              }}
            >
              <Link className="me-3 text-primary">
                <i className="mdi mdi-eye font-size-18"></i>
              </Link>
            </div>
          </div>
        ),
      },
    ],
    [page, pageSize]
  );

  const exportData = dataForExport?.map((item, index) => ({
    "Sr. No": index + 1,
    "USER TYPE":
      item?.type === 1
        ? "Subcontractor"
        : item?.type === 2
        ? "Customer"
        : "N/A",
    "COMPANY NAME": item?.company_name || "N/A",
    "CONTACT PERSON": item?.contact_person_name || "N/A",
    STATUS:
      item?.is_active === false || item?.is_active === 0
        ? "In-active"
        : "Active",
  }));

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              marginBottom: "10px",
            }}
          >
            <Breadcrumb
              title="Create Subcontractor & Customer List"
              breadcrumbItems={breadcrumbItems}
            />
            <Button
              color="primary"
              className="waves-effect waves-light me-1"
              onClick={handleClickAdd}
              style={{ marginLeft: "auto", background: "#006eb9" }}
            >
              Create Subcontractor & Customer
            </Button>
          </div>

          <Card>
            <CardBody>
              <TableContainer
                columns={columns || []}
                data={data || []}
                isPagination={false}
                // isGlobalFilter={false}
                iscustomPageSize={false}
                isBordered={false}
                customPageSize={10}
                isLoading={isLoading}
                onSearchInputData={getSearchInputData}
                pageIndexProp={page}
                onPageSizeChange={handlePageSizeChange}
                nextToPage={nextToPages}
                lastToPage={lastToPages}
                previousToPage={previousToPages}
                previousFirstToPage={previousFirstToPages}
                totalCount={totalCount}
                exportData={exportData}
                exportFileName={exportFileName}
              />
            </CardBody>
          </Card>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default SubcontractorAndCustomerList;
